import { useNavigation } from '@react-navigation/native'
import { Alert, Box, Button, Heading, Text, VStack } from 'native-base'
import { useEffect, useState } from 'react'
import { Linking } from 'react-native'
import { useDesktopBreakpoint } from '../../../domain/services/useBreakpoint'
import FaIcon from '../components/_shared/FaIcon'
import FormInput from '../components/_shared/form/FormInput'
import FormLayout from '../layouts/FormLayout'
import { useCabanaApi } from '../providers/CabanaApiProvider'

const Wave = require('../../views/assets/images/login/wave-login.png')

const ChangePasswordScreen = () => {
  const { MemberProfileApi } = useCabanaApi()
  const navigation = useNavigation()
  const isDesktop = useDesktopBreakpoint()

  const [password, setPassword] = useState('')
  const [valid, setValid] = useState(false)
  const [waiting, setWaiting] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)

  const passwordRequirements = [
    {
      text: 'Lowercase',
      symbol: 'abc',
      logic: (password) => !!password.match(/[a-z]/),
    },
    {
      text: 'Uppercase',
      symbol: 'ABC',
      logic: (password) => !!password.match(/[A-Z]/),
    },
    {
      text: 'Number',
      symbol: '123',
      logic: (password) => !!password.match(/[0-9]/),
    },
    {
      text: 'Symbol',
      symbol: '!$%',
      logic: (password) =>
        !!password.match(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/),
    },
    {
      text: 'Characters',
      symbol: '8+',
      logic: (password) => password.length >= 8,
    },
  ]

  const doChangePassword = () => {
    setWaiting(true)
    setError(false)
    MemberProfileApi.changePassword(password)
      .then(() => setSuccess(true))
      .catch(() => setError(true))
      .finally(() => setWaiting(false))
  }

  useEffect(() => {
    setWaiting(false)
    setError(false)
    setSuccess(false)
    setValid(false)
  }, [])

  return (
    <FormLayout bg="white">
      {!isDesktop && (
        <Box mt={-4} mx={-6} borderTopWidth={1} borderTopColor="muted.50" />
      )}
      {success ? (
        <VStack h="100%" w="100%" style={{ gap: 12 }}>
          <Heading fontSize={'2xl'} mt="3" color="primary.900">
            Set your new password
          </Heading>
          <Box alignSelf={'center'}>
            <FaIcon name="circle-check" isSolid color="success.700" size={36} />
          </Box>
          <Text textAlign={'center'}>Your password has been changed.</Text>
          <Button onPress={() => navigation.navigate('Profile')}>
            Back to profile
          </Button>
        </VStack>
      ) : (
        <VStack h="100%" w="100%" style={{ gap: 12 }}>
          <Heading fontSize={'2xl'} mt="3" color="primary.900">
            Set your new password
          </Heading>
          <Box mb={-6}>
            <FormInput
              bg="white"
              autofocus
              defaultValue={password}
              label="Password"
              type="password"
              onChangeValid={setValid}
              onChangeText={setPassword}
              inputAccessoryViewID={'form'}
              requirements={passwordRequirements}
            />
          </Box>
          {error && (
            <Alert colorScheme="error" variant="subtle" mt={-4}>
              <Text w="100%" color="text.900">
                We've encountered an error while changing your password.&nbsp;
                <Text
                  underline
                  onPress={() =>
                    Linking.openURL('mailto:support@mycabana.health')
                  }>
                  Contact support
                </Text>
                .
              </Text>
            </Alert>
          )}
          <Button
            isLoading={waiting}
            testID="continue-log-in-button"
            isDisabled={!valid}
            onPress={doChangePassword}>
            Finish
          </Button>
        </VStack>
      )}
    </FormLayout>
  )
}

export default ChangePasswordScreen
